export default "__VITE_ASSET__Dh$hMxWq__"